var _circle, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#4B9BF5",
    fillOpacity: 0.8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.8,
    y: 7.20001,
    width: 2.4,
    height: 15.6,
    rx: 1.2,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.801,
    y: 13.8,
    width: 2.4,
    height: 15.6,
    rx: 1.2,
    transform: "rotate(90 22.801 13.8)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBlue);
export default __webpack_public_path__ + "static/media/plus-blue.dc387c818f445643fd368f04a709d1ad.svg";
export { ForwardRef as ReactComponent };